import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    feedFileListRoot: {
        width: '100%',
        padding: '0 16px 0 16px',
    }
}));